import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import TextArea from "../../form/TextArea";
import Button from "../../form/Button";
import {postData} from "../../../utils/request";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {get} from "../../../utils/dotutils";
import ComponentField from "../../form/ComponentField";

class EventPurchaseForm extends React.Component {

    render() {
        // const isInEdit = this.props.stateType.Modification(this.props.values.state) || get(this, "props.values.origin.partner.partner_id") + "" === "" + get(this, "props.context.partner.partner_id");
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2 col-md-push-10">
                        <TextInput
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-2 col-md-push-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="pid"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                    {/* <div className="col-sm-3 col-md-pull-4">
                        <TextInput
                            {...this.props.getFieldProps("StockOperationState")}
                            disabled="disabled"
                            name="StockOperationState"
                            value={this.props.values.StockOperationState}
                            formatter={OptionFormatter}
                            label="Státusz"/>
                    </div> */}
                    <div className="col-sm-2 col-md-pull-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("orderdate")}
                            name="orderdate"
                            disabled="disabled"
                            value={this.props.values.orderdate}
                            label="Rögzítés dátuma"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    {/* <div className="col-sm-3 col-md-pull-4">
                        <label className="control-label">Elszámolás dátuma</label>
                        <div className="input-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("transaction_date")}
                                name="transaction_date"
                                value={this.props.values.transaction_date}
                                label={false}
                                showTime={false}
                                disabled={this.props.values.state > 520 || this.props.isLoading}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.transaction_date === this.props.initialValues.transaction_date ? "default" : "primary"}
                                    disabled={this.props.values.transaction_date === this.props.initialValues.transaction_date || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    transaction_date: this.props.values.transaction_date
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="pos"
                            label="Eladás helye"
                            disabled={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {/* {this.props.partnerType === "customer" && <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            {...this.props.getFieldProps("agent")}
                            disabled={"disabled"}
                            objectValue={true}
                            name="agent"
                            component="user"
                            labelKey="name"
                            valueKey="id"
                            storeType="remote"
                            value={this.props.values.agent}
                            saveChanges={this.props.setFieldValue}
                            label="Vevő"
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.telnum"
                            value={(this.props.values.agent || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>} */}
                <div className="row form-row">
                    {/* {isInEdit ? */}
                     <div className="col-md-3">
                            <label className="control-label">Partner</label>
                            <div className="input-group">
                                <Select
                                    objectValue={true}
                                    name={this.props.partnerType}
                                    component="partner"
                                    labelKey="name"
                                    valueKey="partner_id"
                                    storeType="remote"
                                    view={["address","telnum"]}
                                    value={this.props.values[this.props.partnerType]}
                                    saveChanges={this.props.setFieldValue}
                                    label={false}
                                    {...this.props.getFieldProps(this.props.partnerType)}
                                />
                                <div className="input-group-btn">
                                    <Button
                                        color={get(this, "props.values." + this.props.partnerType + ".partner_id") + "" === "" + get(this, "props.initialValues." + this.props.partnerType + ".partner_id") ? "default" : "primary"}
                                        disabled={get(this, "props.values." + this.props.partnerType + ".partner_id") + "" === "" + get(this, "props.initialValues." + this.props.partnerType + ".partner_id") || this.props.isLoading}
                                        onClick={async () => {
                                            await this.props.processAction(async () => {
                                                return await postData({
                                                    action: this.props.componentConfig.componentname + '.update',
                                                    data: {
                                                        [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                        [this.props.partnerType]: get(this, "props.values." + this.props.partnerType + ".partner_id")
                                                    }
                                                });
                                            });
                                        }}>
                                        Mentés
                                    </Button>
                                </div>
                            </div>
                    </div> 
                    {/* : <div className="col-md-3">
                        <Select
                            objectValue={true}
                            name={this.props.partnerType}
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            view={["address","telnum"]}
                            value={this.props.values[this.props.partnerType]}
                            saveChanges={this.props.setFieldValue}
                            label="Partner"
                            disabled="disabled"
                            {...this.props.getFieldProps(this.props.partnerType)}
                        />
                    </div>} */}
                    <div className="col-md-6">
                        <div className="row">
                            <AddressControl
                                disabled={"disabled"}
                                name={this.props.partnerType + ".address"}
                                value={(this.props.values[this.props.partnerType] || {}).address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            {...this.props.getFieldProps(this.props.partnerType)}
                            disabled="disabled"
                            name={this.props.partnerType + ".telnum"}
                            value={(this.props.values[this.props.partnerType] || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Megjegyzés</label>
                        <div className="input-group comment">
                            <TextArea
                                {...this.props.getFieldProps("comment")}
                                name="comment"
                                value={this.props.values.comment}
                                label={false}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.comment === this.props.initialValues.comment ? "default" : "primary"}
                                    disabled={this.props.values.comment === this.props.initialValues.comment || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    comment: this.props.values.comment
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Foglalások</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("items")}
                                ref={(e) => this.vouchers = e}
                                className={"p-small-table"}
                                // view={["event.from", "event.to"]}
                                // "event.dates": {renderer: (value, rowData) => {
                                //     return rowData.event.from + " - " + rowData.event.to;
                                // }},
                                columns={{
                                    "id": {header: 'Kód', width: 1},
                                    "agent.name": {header: 'Foglaló', width: 2},
                                    "participant_qty": {header: 'Létszám', width: 1, renderer: (value) => value + " Fő"},
                                    "event.from": {header: 'Időtartam', width: 1},
                                    "event.to": {header: 'Időtartam', width: 1},
                                    "event.locations": {header: 'Hely', width: 2, renderer: (locations) => (locations || []).map((location) => location.name).join(", ")},
                                    "event.program.name": {header: 'Program', width: 2}
                                }}
                                listfield="items"
                                data={this.props.values}
                                orderBy={{field: "agent.name", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(EventPurchaseForm);
